var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmnixLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 24,
    viewBox: "0 0 204 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.75 11.8601C58.75 10.5734 58.9746 9.39859 59.3957 8.30769C59.8169 7.21678 60.4345 6.23776 61.1926 5.42657C61.9506 4.61538 62.8771 3.97202 63.972 3.4965C65.0389 3.02097 66.218 2.7972 67.5095 2.7972C68.7729 2.7972 69.952 3.02097 71.047 3.4965C72.1138 3.97202 73.0684 4.58741 73.8264 5.42657C74.6125 6.23776 75.2021 7.21678 75.6513 8.30769C76.0725 9.39859 76.2971 10.6014 76.2971 11.8601C76.2971 13.1189 76.0725 14.3217 75.6513 15.4126C75.2302 16.5035 74.6125 17.4825 73.8264 18.2937C73.0403 19.1049 72.1138 19.7482 71.047 20.2238C69.9801 20.6993 68.801 20.9231 67.5095 20.9231C66.218 20.9231 65.0389 20.6993 63.972 20.2238C62.9051 19.7482 61.9787 19.1329 61.1926 18.2937C60.4345 17.4825 59.8449 16.5035 59.3957 15.4126C58.9746 14.3217 58.75 13.1189 58.75 11.8601ZM63.0736 11.8601C63.0736 12.5315 63.1859 13.1748 63.4386 13.7343C63.6632 14.3217 64.0001 14.7972 64.3931 15.2447C64.7862 15.6643 65.2635 16 65.825 16.2238C66.3584 16.4475 66.948 16.5874 67.5376 16.5874C68.1271 16.5874 68.7167 16.4755 69.2502 16.2238C69.7836 16 70.2609 15.6643 70.682 15.2447C71.1031 14.8252 71.412 14.3217 71.6646 13.7343C71.8892 13.1468 72.0296 12.5315 72.0296 11.8601C72.0296 11.1888 71.9173 10.5454 71.6646 9.98601C71.412 9.39859 71.1031 8.92307 70.682 8.47552C70.2609 8.05594 69.7836 7.72027 69.2502 7.4965C68.7167 7.27272 68.1271 7.13286 67.5376 7.13286C66.948 7.13286 66.3584 7.24475 65.825 7.4965C65.2915 7.72027 64.8143 8.05594 64.3931 8.47552C64.0001 8.8951 63.6632 9.39859 63.4386 9.98601C63.1859 10.5454 63.0736 11.1608 63.0736 11.8601Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0551 20.4196L79.6661 3.27272H83.6247L86.713 12.4196L89.7732 3.27272H93.7318L96.3428 20.4196H92.3561L91.0366 10.5454L87.3868 20.4196H85.7865L82.3894 10.5734L81.0418 20.4196H77.0551Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0554 20.4196V3.30069H102.182L109.819 13.7902V3.30069H113.946V20.4196H109.819L102.182 9.93006V20.4196H98.0554Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.442 3.30069V20.4196H116.978V3.30069H121.442Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.532 0.0046187L135.1 6.41302L138.792 10.0919L145.224 3.68352L141.532 0.0046187Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.23 20.2627L138.798 13.8543L135.106 17.5332L141.538 23.9416L145.23 20.2627Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.192 11.8322L133.823 8.44754L125.457 0.111877L121.751 3.80418L130.145 12.1398L121.948 20.3077L125.625 24L137.529 12.1398L137.192 11.8322Z",
    fill: "#FD0049"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86.5,
    height: 24,
    fill: "white",
    transform: "translate(58.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmnixLogo);
export default __webpack_public_path__ + "static/media/omnix-logo.c569d3e27acd219631ac8d01dcb3f0c8.svg";
export { ForwardRef as ReactComponent };